(function($) {
    "use strict";

    // Return if not proper template
    if ( !$('body').hasClass('page-template-hub-policy-research') ) return;

    $(function() {
        var wfdcURIstring = '',
            nationalFilterByVariable = $('select.national-level-variable').select2({
            placeholder: 'Data type',
            minimumResultsForSearch: Infinity,
            allowClear: true,
            dropdownCssClass: "dark-dropdown"
        });

        nationalFilterByVariable.on( 'select2:select', function( event ) {
            var value = nationalFilterByVariable.val();
            updateURIParameterByName( 'natvar', encodeSpacesToPlus(value) );
        });

        var stateFilterByVariable = $('select.state-level-variable').select2({
            placeholder: 'Data type',
            minimumResultsForSearch: Infinity,
            allowClear: true,
            dropdownCssClass: "dark-dropdown"
        });

        stateFilterByVariable.on( 'select2:select', function( event ) {
            var value = stateFilterByVariable.val();
            updateURIParameterByName( 'var', encodeSpacesToPlus(value) );
        });

        var stateList = us.STATES,
            formattedStateList = [];

        $.each( stateList, function( index ) {
            var newKeyValue = {};
            newKeyValue.id = this.name;
            newKeyValue.text = this.name;
            formattedStateList.push(newKeyValue);
        });

        var filterByState = $('select.state-level-state').select2({
            minimumResultsForSearch: Infinity,
            placeholder: 'State',
            allowClear: true,
            data: formattedStateList,
            dropdownCssClass: "dark-dropdown"
        });

        filterByState.on( 'select2:select', function( event ) {
            var value = filterByState.val();
            updateURIParameterByName( 'states', value );
        });

        $( '.hub-page-policy-section__action a' ).click( function( event ) {
            event.preventDefault();
            var clickedLink = $( this ),
                href = clickedLink.attr( 'href' ),
                parent = clickedLink.parent();

            if ( parent.hasClass('state') ) {
                updateURIParameterByName( 'tab', encodeSpacesToPlus('State Data') );
            } else if ( parent.hasClass('national') ) {
                updateURIParameterByName( 'tab', encodeSpacesToPlus('National Data') );
            }

            window.location.href = href + wfdcURIstring;
        });

        $('#resource-jump-link').click(function(e) {
            e.preventDefault();

            var type = $('#hub-resource-type option:selected').text(),
                issue = $('#hub-resource-issue option:selected').text();

            window.location.href = '/policy-research/reports-multimedia/#type=' + encodeURIComponent(type) + '&issue=' + encodeURIComponent(issue);

            return false;
        });

        // Spaces to plus signs
        function encodeSpacesToPlus( string ) {
            if ( string === null ) return null;
            return string.split( ' ' ).join( '+' );
        };

        // Update URI vars
        var updateURIParameterByName = function( name, value ) {
            var re = new RegExp("([#&])" + name + "=.*?(&|$)", "i"),
                separator = wfdcURIstring.indexOf('#') !== -1 ? "&" : "#",
                updatedURL = '';
            if ( value === null ) value = '';
            if (wfdcURIstring.match(re)) {
                if ( value === '' ) {
                  updatedURL = wfdcURIstring.replace(re, '$1' + '$2');
                } else {
                  updatedURL = wfdcURIstring.replace(re, '$1' + name + "=" + value + '$2');
                }
            } else {
                if ( value === '' ) {
                  updatedURL = wfdcURIstring;
              } else {
                  updatedURL = wfdcURIstring + separator + name + "=" + value;
              }
            }
            wfdcURIstring = updatedURL.replace('&&','&');
        };
    });
})(jQuery);
